










import {
  KitDinamico,
  KitsDinamicosService,
} from "@/services/kits-dinamicos.service";
import { Component, Vue } from "vue-property-decorator";
import KitDinamicoForm from "./KitDinamicoForm.vue";
import Loading from "@/shared/components/loading.vue";
@Component({
  components: { KitDinamicoForm, Loading },
  filters: {},
})
export default class NovoKitDinamico extends Vue {
  kitDinamico: KitDinamico | null = {
    descricao: "",
    codigoFornecedor: "",
    aplicaDesconto: false,
    excluido: true,
    validoApos: "",
    validoAte: "",
    preco: 0,
  };
  loading = false;

  async mounted() {
    const idCopia = this.$route.query?.idCopia;

    if (idCopia) {
      try {
        this.loading = true;
        this.kitDinamico = await KitsDinamicosService.obterKitDinamico(
          idCopia as string
        );
        this.kitDinamico.idKitDinamico = undefined;
      } finally {
        this.loading = false;
      }
    } else {
      this.kitDinamico = {
        descricao: "",
        codigoFornecedor: "",
        aplicaDesconto: false,
        excluido: true,
        validoApos: "",
        validoAte: "",
        preco: 0,
      };
    }
  }

  formSaved(id: string) {
    this.$router.replace({
      name: "alterar-kitdinamico",
      params: { id },
    });
  }
}
